

import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface DoctorsAvailParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface DoctorsAvail {
    id?: any;
    tenantId: any;
    branchId: any;
    doctorId: any;
    branch?:any;
    startTime: any;
    endTime: any;
    toDate: Date;    
    fromDate: Date;
    timeSlotInMin: number;
    available: boolean;
    unavailabilityReasonType: string;
    reason?:string; //new reason column added by Raja 10-02-2022
    parameters?: DoctorsAvailParameter[];
    links?: any;
    noOfSlots?:  number;
    noOfSlotsFromMobileApp?:  number;

    
}
export interface DashboardDocList{
    id:any;
    name:string;
    dept:string;
    startTime: any;
    endTime: any;
    toDate: Date;
    fromDate: Date;
}

export abstract class DoctorsAvailData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<DoctorsAvail[]>;
    abstract create(url: string, data: DoctorsAvail): Observable<DoctorsAvail>;
    abstract bulkUpdate(url: string, data: DoctorsAvail[]): Observable<DoctorsAvail>;
    abstract update(url: string, data: DoctorsAvail): Observable<DoctorsAvail>;
    abstract delete(url: string): Observable<any>;
}